import { type ReactNode } from 'react';

export type BadgeVariant = 'info' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'outline';
export type BadgeSize = 'none' | 'xs' | 'sm' | 'md';

export interface BadgeProps {
  children: ReactNode;
  size?: BadgeSize;
  variant?: BadgeVariant;
}

const BASE_CLASSES = 'inline-flex items-center rounded-md border font-medium';

const SIZE_CLASSES: Record<BadgeSize, string> = {
  none: '',
  xs: 'px-3 py-1 text-xs',
  sm: 'px-4 py-2 text-sm',
  md: 'px-5 py-3 text-base',
};

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
    info: 'border-mp-info/20 bg-mp-info-content text-mp-info',
    primary: 'border-mp-primary/20 bg-mp-primary-content text-mp-link',
    secondary: 'border-mp-secondary/20 bg-mp-secondary-content text-mp-secondary',
    success: 'border-mp-success/20 bg-mp-success-content text-mp-success',
    warning: 'border-mp-warning/20 bg-mp-warning-content text-mp-warning',
    error: 'border-mp-error/20 bg-mp-error-content text-mp-error',
    outline: 'border-mp-input text-mp-foreground',
};

export const Badge: React.FC<BadgeProps> = ({ children, size = 'xs', variant = 'primary' }) => (
  <span className={`${BASE_CLASSES} ${SIZE_CLASSES[size]} ${VARIANT_CLASSES[variant]}`}>{children}</span>
);
